import { useState } from 'react';

import format from 'date-fns/format';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import QrReader from 'react-qr-reader';

import { Header } from './layout/Header';

import {
  fetchTrackingInfo,
  reset,
  selectTotal,
  selectTracking,
} from './homeSlice';

function isExpired(date) {
  return new Date().getTime() > date.getTime();
}

export function Home() {
  const { register, handleSubmit, watch, setValue } = useForm();
  const dispatch = useDispatch();
  const total = useSelector(selectTotal);
  const tracking = useSelector(selectTracking);
  const [scanQr, setScanQr] = useState(false);

  const handleScan = (data) => {
    if (data) {
      setValue('id', data);
      dispatch(
        fetchTrackingInfo({
          id: data,
        })
      );
      setScanQr(false);
    }
  };

  const handleError = () => {
    setScanQr(false);
    alert('Vui lòng cấp quyền camera để sử dụng tính năng này');
  };

  return (
    <>
      <Header />
      <Container className="mt-3">
        <Row>
          <Col>
            <h4>Kiểm tra bảo hành</h4>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form
              onSubmit={handleSubmit((values) => {
                dispatch(fetchTrackingInfo(values));
              })}
            >
              <Form.Group>
                <Form.Label>Kiểm tra bảo hành theo</Form.Label>
                <Form.Check
                  id="typePhone"
                  label="Số điện thoại"
                  name="trackingType"
                  ref={register}
                  type="radio"
                  value="phone"
                  onChange={() => {
                    dispatch(reset());
                    setValue('trackingType', 'phone');
                    setValue('id', '');
                  }}
                />
                <Form.Check
                  id="typeProductId"
                  label="Serial"
                  name="trackingType"
                  ref={register}
                  type="radio"
                  value="product_id"
                  onChange={() => {
                    dispatch(reset());
                    setValue('trackingType', 'product_id');
                    setValue('id', '');
                  }}
                />
              </Form.Group>
              {watch('trackingType') && (
                <Form.Group>
                  <Form.Control
                    name="id"
                    placeholder={
                      watch('trackingType') === 'phone'
                        ? 'Nhập số điện thoại'
                        : 'Nhập serial'
                    }
                    ref={register}
                    type="text"
                  />
                </Form.Group>
              )}
              {watch('id') && (
                <Button type="submit" variant="primary">
                  Kiểm tra bảo hành
                </Button>
              )}
            </Form>
          </Col>
          <Col>
            {total === 0 ? (
              'Chưa có thông tin bảo hành'
            ) : (
              <>
                <p>Tổng số sản phẩm: {total}</p>
                {tracking.map((item) => (
                  <Card
                    border={
                      isExpired(new Date(item.warrantlyExpirationDate))
                        ? 'danger'
                        : 'success'
                    }
                    className="mb-3"
                  >
                    <Card.Header>
                      <Card.Title className="mb-0">
                        {item.sku.skuName}
                      </Card.Title>

                      <small>
                        (Serial:{' '}
                        <code style={{ fontSize: 14 }}>{item.productId}</code>)
                      </small>
                    </Card.Header>
                    <Card.Body>
                      <h5>{item.customer.name}</h5>
                      <Card.Text>
                        Mã khách hàng: <code>{item.customer.customerId}</code>
                      </Card.Text>
                      <Card.Text>Địa chỉ: {item.customer.address}</Card.Text>
                      <Card.Text>
                        Tình trạng bảo hành:{' '}
                        <strong
                          className={
                            isExpired(new Date(item.warrantlyExpirationDate))
                              ? 'text-danger'
                              : 'text-success'
                          }
                        >
                          {isExpired(new Date(item.warrantlyExpirationDate))
                            ? 'Hết bảo hành miễn phí'
                            : 'Còn bảo hành miễn phí'}
                        </strong>
                      </Card.Text>
                      <Card.Text>
                        Ngày lắp đặt:{' '}
                        <code>
                          {format(
                            new Date(item.installationDate),
                            'dd/MM/yyyy'
                          )}
                        </code>
                      </Card.Text>
                      <Card.Text>
                        Ngày hết hạn bảo hành:{' '}
                        <code>
                          {format(
                            new Date(item.warrantlyExpirationDate),
                            'dd/MM/yyyy'
                          )}
                        </code>
                      </Card.Text>
                      {item.sku.skuPictures.map((i, index) => (
                        <a href={i} target="_blank" rel="noopener noreferrer">
                          <img
                            alt=""
                            className="img-thumbnail"
                            key={index}
                            src={i}
                            width={40}
                          />
                        </a>
                      ))}
                    </Card.Body>
                  </Card>
                ))}
              </>
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              onClick={() => {
                setScanQr(!scanQr);
                setValue('trackingType', 'product_id');
              }}
            >
              {scanQr ? 'Tắt quét mã QR' : 'Quét mã QR'}
            </Button>
            {scanQr && (
              <QrReader
                delay={300}
                onError={handleError}
                onScan={handleScan}
                style={{ width: '100%' }}
              />
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}
